import {
    lazyLoadInternetMessageIdAttachment,
    lazyLoadSxSWithReadingPaneItem,
} from 'owa-mail-sxs-view';
import { PreviewPaneSelectionSource } from 'owa-sxs-store';

export interface AttachmentRouteParamaters {
    itemId: string;
    attachmentId: string;
    groupDomain?: string;
    groupAlias?: string;
    isEdit?: string;
}

async function deepLinkAttachmentRouteHandler(parameters: AttachmentRouteParamaters) {
    if (parameters.itemId && parameters.attachmentId) {
        const loadSxSWithReadingPaneItem = await lazyLoadSxSWithReadingPaneItem.import();
        const groupId =
            parameters.groupDomain && parameters.groupAlias
                ? `${parameters.groupAlias}@${parameters.groupDomain}`
                : null;
        const isEdit: boolean = parameters.isEdit === 'true';
        await loadSxSWithReadingPaneItem(
            parameters.itemId,
            parameters.attachmentId,
            groupId,
            PreviewPaneSelectionSource.Deeplink,
            null /* instrumentationContext */,
            isEdit
        );
    }
}

export default deepLinkAttachmentRouteHandler;

export interface InternetMessageIdAttachmentRouteParamaters {
    base64EncodedInternetMessageId: string;
    attachmentIndex: string;
}

function deepLinkInternetMessageIdAttachmentRouteHandler(
    parameters: InternetMessageIdAttachmentRouteParamaters
) {
    lazyLoadInternetMessageIdAttachment.importAndExecute(
        atob(parameters.base64EncodedInternetMessageId),
        Number(parameters.attachmentIndex)
    );
}

export { deepLinkInternetMessageIdAttachmentRouteHandler };
